


















































export default {
    name: 'CoAlert',
    props: {
        variant: {
            type: String,
            default: 'red',
            validator(value) {
                return ['red', 'yellow', 'grey', 'green', 'midgrey'].includes(value);
            },
        },
        text: {
            type: String,
            default: 'No text provided',
        },
    },
    computed: {
        classes() {
            return {
                [this.variant]: true,
            };
        },
    },
};
